var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[_c('h1',{staticClass:"title has-text-centered"},[_vm._v("Home (404)")]),_c('article',{staticClass:"notification is-primary"},[_c('p',[_vm._v("Oops. Something went wrong.")])])])
}]

export { render, staticRenderFns }